import Radium from "radium";
import React from "react";

import { menuStyles } from "@common/styles";

export interface IMenuItemProps {
  handleClick: () => void;
  title: string;
}

const menuItem: React.StatelessComponent<IMenuItemProps> = ({
  handleClick,
  title
}) => (
  <div style={{ margin: 0 }}>
    <button
      style={menuStyles.menuItem as any}
      type="button"
      onClick={handleClick}
    >
      {title}
    </button>
  </div>
);

export default Radium(menuItem);
